import { render, staticRenderFns } from "./UpgradeAccount.vue?vue&type=template&id=8ab0411a&scoped=true"
import script from "./UpgradeAccount.vue?vue&type=script&lang=js"
export * from "./UpgradeAccount.vue?vue&type=script&lang=js"
import style0 from "./UpgradeAccount.vue?vue&type=style&index=0&id=8ab0411a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab0411a",
  null
  
)

export default component.exports